<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.ta_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="ta_rpname">
            <label class="weui-form-preview__label">{{
              customLabel.ta_rpname || "研发阶段"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ta_rpname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ta_taskroute">
            <label class="weui-form-preview__label">{{
              customLabel.ta_taskroute || "研发路径"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ta_taskroute
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ta_pjcode">
            <label class="weui-form-preview__label">{{
              customLabel.ta_pjcode || "项目单号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ta_pjcode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pj_dename">
            <label class="weui-form-preview__label">{{
              customLabel.pj_dename || "项目名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pj_dename
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pj_emname">
            <label class="weui-form-preview__label">{{
              customLabel.pj_emname || "项目负责人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pj_emname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pj_emtel">
            <label class="weui-form-preview__label">{{
              customLabel.pj_emtel || "联系电话"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pj_emtel
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pj_begin_date">
            <label class="weui-form-preview__label">{{
              customLabel.pj_begin_date || "开始时间"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.pj_begin_date
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pj_end_date">
            <label class="weui-form-preview__label">{{
              customLabel.pj_end_date || "完成日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.pj_end_date
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ta_taskstatus">
            <label class="weui-form-preview__label">{{
              customLabel.ta_taskstatus || "状态"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ta_taskstatus
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ta_task">
            <label class="weui-form-preview__label">{{
              customLabel.ta_task || "任务名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ta_task
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ta_emname">
            <label class="weui-form-preview__label">{{
              customLabel.ta_emname || "责任人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ta_emname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ta_role">
            <label class="weui-form-preview__label">{{
              customLabel.ta_role || "岗位"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ta_role
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ta_planbegindate">
            <label class="weui-form-preview__label">{{
              customLabel.ta_planbegindate || "计划开始日期"
            }}</label>
            <span
              class="weui-form-preview__value"
              v-format="'yyyy-MM-dd hh:mm'"
              >{{ form.main.ta_planbegindate }}</span
            >
          </div>
          <div class="weui-form-preview__item" slot="ta_planenddate">
            <label class="weui-form-preview__label">{{
              customLabel.ta_planenddate || "计划结束日期"
            }}</label>
            <span
              class="weui-form-preview__value"
              v-format="'yyyy-MM-dd hh:mm'"
              >{{ form.main.ta_planenddate }}</span
            >
          </div>
          <div class="weui-form-preview__item" slot="ta_planworkhour">
            <label class="weui-form-preview__label">{{
              customLabel.ta_planworkhour || "计划工时"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ta_planworkhour
            }}</span>
          </div>

          <div class="weui-form-preview__item" slot="ta_actbegindate">
            <label class="weui-form-preview__label">{{
              customLabel.ta_actbegindate || "实际开始日期"
            }}</label>
            <span
              class="weui-form-preview__value"
              v-format="'yyyy-MM-dd hh:mm'"
              >{{ form.main.ta_actbegindate }}</span
            >
          </div>
          <div class="weui-form-preview__item" slot="ta_actenddate">
            <label class="weui-form-preview__label">{{
              customLabel.ta_actenddate || "实际结束日期"
            }}</label>
            <span
              class="weui-form-preview__value"
              v-format="'yyyy-MM-dd hh:mm'"
              >{{ form.main.ta_actenddate }}</span
            >
          </div>
          <div class="weui-form-preview__item" slot="ta_actworkhour">
            <label class="weui-form-preview__label">{{
              customLabel.ta_actworkhour || "实际工时"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ta_actworkhour
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="rd_taskreq">
            <label class="weui-form-preview__label">{{
              customLabel.rd_taskreq || "任务要求"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.rd_taskreq
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ta_taskreq">
            <label class="weui-form-preview__label">{{
              customLabel.ta_taskreq || "已达成要求"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ta_taskreq
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview" v-show="form.items1 > 0">
        <div class="weui-panel__hd visit-record-reply">
          <p>退回记录</p>
        </div>
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items1"
          :key="item.id"
        >
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="creatorName">
              <label class="weui-form-preview__label">{{
                customLabel.creatorName || "姓名"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.creatorName }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="ptr_emname">
              <label class="weui-form-preview__label">{{
                customLabel.ptr_emname || "回复对象"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.ptr_emname }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="ptr_context">
              <label class="weui-form-preview__label">{{
                customLabel.ptr_context || "回复内容"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.ptr_context }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="createTime">
              <label class="weui-form-preview__label">{{
                customLabel.createTime || "回复时间"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                v-format="'yyyy-MM-dd'"
                >{{ item.createTime }}
              </span>
            </div>
          </custom-layout>
        </div>
      </div>
      <div class="tab">
        <a :class="{ active: activity == 1 }" @click="setActivity(1)"
          >配置需求明细</a
        >
        <a :class="{ active: activity == 2 }" @click="setActivity(2)"
          >主要参数</a
        >
      </div>
      <collapse
        class="form-preview weui-form-preview"
        :title="'配置需求明细（' + form.items2?.length + '条）'"
        v-show="activity == 1"
      >
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items2"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.dd_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail2">
            <div class="weui-form-preview__item" slot="dd_name">
              <label class="weui-form-preview__label">{{
                customLabel.dd_name || "名称"
              }}</label>
              <span class="weui-form-preview__value">{{ item.dd_name }}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_spec">
              <label class="weui-form-preview__label">{{
                customLabel.dd_spec || "规格"
              }}</label>
              <span class="weui-form-preview__value">{{ item.dd_spec }}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_brand">
              <label class="weui-form-preview__label">{{
                customLabel.dd_brand || "品牌"
              }}</label>
              <span class="weui-form-preview__value">{{ item.dd_brand }}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_colour">
              <label class="weui-form-preview__label">{{
                customLabel.dd_colour || "颜色"
              }}</label>
              <span class="weui-form-preview__value">{{ item.dd_colour }}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_size">
              <label class="weui-form-preview__label">{{
                customLabel.dd_size || "尺寸"
              }}</label>
              <span class="weui-form-preview__value">{{ item.dd_size }}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_texture">
              <label class="weui-form-preview__label">{{
                customLabel.dd_texture || "材质"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.dd_texture
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_silkscreen">
              <label class="weui-form-preview__label">{{
                customLabel.dd_silkscreen || "丝印"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.dd_silkscreen
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_standard">
              <label class="weui-form-preview__label">{{
                customLabel.dd_standard || "标准"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.dd_standard
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_remark">
              <label class="weui-form-preview__label">{{
                customLabel.dd_remark || "备注"
              }}</label>
              <span class="weui-form-preview__value">{{ item.dd_remark }}</span>
            </div>
            <custom-field
              :readOnly="true"
              :label="customLabel.dd_text1 || '自定义字段1'"
              v-model="form.main.dd_text1"
              slot="dd_text1"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.dd_text2 || '自定义字段2'"
              v-model="form.main.dd_text2"
              slot="dd_text2"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.dd_text3 || '自定义字段3'"
              v-model="form.main.dd_text3"
              slot="dd_text3"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.dd_text4 || '自定义字段4'"
              v-model="form.main.dd_text4"
              slot="dd_text4"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.dd_text5 || '自定义字段5'"
              v-model="form.main.dd_text5"
              slot="dd_text5"
              hidden="true"
            />
          </custom-layout>
        </div>
      </collapse>
      <collapse
        class="form-preview weui-form-preview"
        :title="'主要参数（' + form.items3?.length + '条）'"
        v-show="activity == 2"
      >
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="main in form.items3"
          :key="main.id"
        >
          <div class="form-detail-preview_num">{{ main.pp_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail3">
            <div class="weui-form-preview__item" slot="pp_name">
              <label class="weui-form-preview__label">{{
                customLabel.pp_name || "参数名称"
              }}</label>
              <span class="weui-form-preview__value">{{ main.pp_name }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pp_value">
              <label class="weui-form-preview__label">{{
                customLabel.pp_value || "参数值"
              }}</label>
              <span class="weui-form-preview__value">{{ main.pp_value }}</span>
            </div>
          </custom-layout>
        </div>
      </collapse>

      <file-list v-model="form.main.de_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <a
        href="javascript:;"
        v-if="form.main.ta_taskstatus != '项目终止'"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="turn_problem"
        >问题反馈</a
      >
      <a
        href="javascript:;"
        v-if="form.main.ta_taskstatus == '待启动'"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_rollback"
        >任务回退</a
      >
      <router-link
        :to="'/plm/proj_task_edit?id=' + form.main.id"
        v-if="form.main.ta_taskstatus != '完成'"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="form.main.ta_taskstatus == '已启动'"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="submit"
        >提交</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反提交</a
      >
    </div>
    <div class="mark" v-if="pindex != -1">
      <div class="page page__has-bar">
        <div class="page__bd">
          <div class="weui-cell">
            <div class="weui-cell__hd">
              <label class="weui-label">{{
                customLabel.comment || "理由"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <textarea
                class="weui-textarea"
                rows="5"
                autofocus
                v-model="comment"
                placeholder="请输入理由"
                placeholder-class="weui-input__placeholder"
              />
            </div>
          </div>
        </div>
        <div class="footer-bar weui-dialog__ft">
          <a
            href="javascript:;"
            class="weui-dialog__btn weui-dialog__btn_primary"
            @click="f_rollback_submit"
            >确定</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import Collapse from "@/components/Collapse.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    Collapse,
    FileList,
  },
  data() {
    return {
      activity: 1,
      baseUrl: "/api/plm/projtask",
      codeField: "ta_code",
      statusField: "ta_statuscode",
      caller: "PlmProjTask",
      xtype: "plm-projtask-formpanel",
      pindex: -1,
      comment: "",
    };
  },
  methods: {
    setActivity: function (activity) {
      this.activity = activity;
    },
    f_rollback: function () {
      this.pindex = 1;
    },
    f_rollback_submit: function () {
      let me = this;
      if (!me.comment) {
        me.$weui.topTips("请填写回退理由！", 2000);
        return;
      }

      let params = {
        id: me.form.main.id,
        comment: me.comment,
      };
      me.$loading({
        url: "/api/plm/projtask/returnTask",
        jsonData: params,
        method: "POST",
        loading: true,
      })
        .then(() => {
          me.$weui.toast("任务回退成功", 2000);
          this.pindex = -1;
        })
        .catch((e) => {
          me.$weui.topTips(e.message, 3000);
        });
    },
    submit() {
      var me = this,
        main = me.form.main;
      if (!main.ta_taskreq) {
        me.$weui.topTips("请编辑已达成要求", 2000);
      } else {
        me.$ajax({
          url: "/api/plm/projtask/submit/" + main.id,
          method: "POST",
        }).then(function (res) {
          if (res.success) {
            me.$weui.toast("提交成功", 2000);
            setTimeout(() => {
              me.$router.go(0);
            }, 1500);
          } else {
            me.$weui.topTips(res.message, 3000);
          }
        });
      }
    },
    turn_problem() {
      var me = this;
      me.$router.push({
        name: "ProblemFeedbackEdit",
        params: {
          form: me.form,
        },
      });
    },
  },
};
</script>

<style scoped>
.tab {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  background: #fff;
}
.tab > a {
  padding: 10px 20px;
}
.tab > .active {
  color: #1c8ef0;
}

.mark {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background: #fff;
  z-index: 500;
  overflow-y: scroll;
}
.flex {
  display: flex;
}
.flex-center {
  align-items: center;
}
.flex-1 {
  flex: 1;
}
.width-20 {
  text-align: center;
  width: 50px;
}
.blue-color {
  color: #576b95;
}
</style>